import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useFormContext, useWatch } from 'react-hook-form';

import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';

export const ESG_PLATFORM_REMARK_ID = 'esg-platform-remark';

const EsgPlatformRemark = () => {
  const { getValues } = useFormContext();
  const { remark } = getValues(`esgDataPlatform`) ?? {}; // Waiting type of form provider

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const esgPlatformRemarkEl = document.getElementById(ESG_PLATFORM_REMARK_ID);

  const [isCompletedTh, isCompletedEn] = useWatch({
    name: ['completedSection.isCompletedTh', 'completedSection.isCompletedEn'],
  });

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        esgPlatformRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="เปิดเผยข้อมูลเกี่ยวข้องกับการปล่อยก๊าซเรือนกระจกบนระบบ SET ESG Data Platform"
              setOpen={open}
              fieldPath="esgDataPlatform.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          esgPlatformRemarkEl
        )}
    </>
  );
};

export default EsgPlatformRemark;
